var React = require('react');

function Right (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.5 0.893311L10.7929 1.60042L20.6924 11.4999L10.7929 21.3994L11.5 22.1065L21.3995 12.207L22.1066 11.4999L21.3995 10.7928L11.5 0.893311Z","fill":"#202020"}));
}

Right.defaultProps = {"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none"};

module.exports = Right;

Right.default = Right;
